import Link from 'next/link'
import React from 'react'

const Hero_5 = () => {
  const hero_5_data = [
    {
      img: '/D1.jpg',
      title: 'Image 1',
      authorImage: '',
      authorName: '051_Hart',
      id: '0Etherium NFT Launching Lab',
    },
    {
      img: '/D2.jpg',
      title: 'Oceania \\\\ OVERSEER 017',
      authorImage: '/images/avatars/avatar_22_rounded.jpg',
      authorName: 'MadeByM1KE',
      id: '1Oceania \\\\ OVERSEER 017',

      subItem: [
        {
          img: '/D3.jpg',
          title: 'Light Bars',
          authorImage: '/images/avatars/avatar_17_rounded.jpg',
          authorName: 'Wow Frens',
          id: '2Light Bars',
        },
      ],
    },
  ]
  return (
    <>
      {/* <!-- Hero --> */}
      <section className="relative py-10 md:pt-10">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
          <img
            width={1519}
            height={773}
            src="/images/gradient.jpg"
            alt="gradient"
            className="h-full w-full object-cover"
          />
        </picture>
        <picture className="pointer-events-none absolute inset-0 -z-10 hidden dark:block">
          <img
            width={1519}
            height={773}
            className="h-full w-full"
            src="/images/gradient_dark.jpg"
            alt="gradient dark"
          />
        </picture>

        <div className="h-full px-6 xl:px-20">
          <div className="grid h-full items-center gap-4 lg:grid-cols-12">
            <div className="col-span-6 flex h-full flex-col items-center justify-center py-2 md:items-start md:py-2 xl:col-span-5 xl:pl-[2%] xl:pr-[2%]">
              <div className="mb-10 w-full sm:flex sm:space-x-4">
                <div className="mb-4 flex-1 rounded-2lg bg-white p-4 text-center dark:bg-white/[.15]">
                  <span className="block font-display text-3xl text-[#8DD059]">
                    10,000
                  </span>
                  <span className="block font-display text-sm text-jacarta-500 dark:text-white">
                    Gen 0
                  </span>
                </div>
                <div className="mb-4 flex-1 rounded-2lg bg-white p-4 text-center dark:bg-white/[.15]">
                  <span className="block font-display text-3xl text-[#737EF2]">
                    5
                  </span>
                  <span className="block font-display text-sm text-jacarta-500 dark:text-white">
                    Chains
                  </span>
                </div>
                <div className="mb-4 flex-1 rounded-2lg bg-white p-4 text-center dark:bg-white/[.15]">
                  <span className="block font-display text-3xl text-[#F35BC7]">
                    $8
                  </span>
                  <span className="block font-display text-sm text-jacarta-500 dark:text-white">
                    Mint Price
                  </span>
                </div>
              </div>
              <h1 className="mb-6 text-center font-display text-5xl text-jacarta-700 dark:text-white md:text-left lg:text-5xl xl:text-6xl">
                DiJT Dragons
              </h1>
              <div className="container mx-auto px-4 py-8">
                <p className="text-gray-700 text-lg mb-4">
                  The DiJT Dragons NFT Collection stands as a premier digital
                  asset suite, showcasing an exclusive array of 10,000 distinct
                  dragon designs (2000 on each chain).
                </p>

                <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                  Key Features Include:
                </h2>
                <ul className="list-disc list-inside space-y-2 text-gray-700">
                  <li>
                    <strong>Breeding Capability:</strong> Owners have the unique
                    opportunity to breed their dragon NFTs, resulting in an
                    offspring that inherits characteristics from its parents.
                  </li>
                  <li>
                    <strong>Multi-Chain Bridging:</strong> Flexibility is
                    enhanced with the option to bridge NFTs across five different
                    blockchains.
                  </li>
                  <li>
                    <strong>Staking Benefits:</strong> Holders can stake their
                    NFTs to accrue DiJT tokens, offering a rewarding investment
                    opportunity.
                  </li>
                  <li>
                    <strong>Diverse Minting Options:</strong> Initially
                    available on three blockchain platforms, with plans to
                    expand to two additional chains, as determined by community
                    voting.
                  </li>
                </ul>

                <p className="text-gray-700 text-lg mt-6">
                  These innovative features will become accessible immediately
                  after the complete minting of the collection on any of the
                  chains, marking a significant advancement in the realm of
                  digital collectibles.
                </p>
              </div>
              {/*<p className="mb-8 text-center text-lg dark:text-jacarta-200 md:text-left">
                The DiJT Dragons NFT collection is a one-of-a-kind digital
                collection featuring 10,000 unique dragon designs. Each dragon
                is represented as a non-fungible token (NFT) which can be
                bought, sold, and traded on the blockchain. The collection is
                constantly evolving, with new dragons being added to the pool on
                a regular basis. One of the unique features of the DiJT Dragons
                collection is the option to "breed" your dragons, which allows
                you to breed two existing dragon NFTs to create a new offspring
                dragon. This offspring dragon will inherit traits from its
                parents. Overall, the DiJT Dragons collection offers a fun and
                immersive experience for collectors, allowing them to build and
                care for their own digital dragon menagerie. Get more info and
                you dragon on DiJT.io.
              </p>
              <div className="flex space-x-4">
                <Link
                  href="/create"
                  className="w-36 rounded-full bg-accent py-3 px-8 text-center font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark"
                >
                  Mint
                </Link>
                <Link
                  href="/collection/explore_collection"
                  className="w-36 rounded-full bg-white py-3 px-8 text-center font-semibold text-accent shadow-white-volume transition-all hover:bg-accent-dark hover:text-white hover:shadow-accent-volume"
                >
                  Bridge
                </Link>
  </div>*/}
            </div>

            {/* <!-- Hero images --> */}
            <div className="relative col-span-6 xl:col-span-6 xl:col-start-7">
              {/*<img
                width={180}
                height={180}
                src="/images/hero/badge.png"
                className="absolute top-0 z-10 -ml-16 animate-spin-slow md:top-[12%]"
                alt="badge"
              />*/}
              <div className="md:flex md:space-x-6 xl:space-x-12">
                {hero_5_data.map((item, index) => {
                  const { id, img, title, authorImage, authorName, subItem } =
                    item
                  const itemLink = img
                    .split('/')
                    .slice(-1)
                    .toString()
                    .replace('_2lg.jpg', '')
                    .replace('.gif', '')
                  return (
                    <div
                      className={
                        index === 0
                          ? 'mb-6 md:flex md:w-1/2 md:items-center'
                          : 'space-y-6 md:w-1/2 xl:space-y-12'
                      }
                      key={id}
                    >
                      <article>
                        <div className="block overflow-hidden rounded-2.5xl bg-white shadow-md transition-shadow hover:shadow-lg dark:bg-jacarta-700">
                          <figure className="relative">
                            <Link href={``}>
                              <img
                                width={406}
                                height={437}
                                src={img}
                                alt="item 1"
                                className="w-full h-full object-cover"
                              />
                            </Link>
                          </figure>
                        </div>
                      </article>

                      {subItem &&
                        subItem.map(
                          ({ id, img, title, authorImage, authorName }) => {
                            const itemLink = img
                              .split('/')
                              .slice(-1)
                              .toString()
                              .replace('.jpg', '')
                              .replace('.gif', '')
                              .replace('_lg', '')
                            return (
                              <div className="md:w-3/4" key={id}>
                                <article>
                                  <div className="block overflow-hidden rounded-2.5xl bg-white shadow-md transition-shadow hover:shadow-lg dark:bg-jacarta-700">
                                    <figure className="relative">
                                      <Link href={`/item/${itemLink}`}>
                                        <img
                                          width={234}
                                          height={234}
                                          src={img}
                                          alt="item 1"
                                          className="w-full h-full object-cover"
                                        />
                                      </Link>
                                    </figure>
                                  </div>
                                </article>
                              </div>
                            )
                          }
                        )}
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- end hero --> */}
    </>
  )
}

export default Hero_5
